import React from 'react';
import {SectionHeader} from '../section/SectionHeader/SectionHeader';
import css from './HeartRateMonitors.module.scss';
import {imageLinks} from './images';
import {devicesLinks} from './links';
import {Section} from '../section/Section';
import {HeartRateMonitor} from './HeartRateMonitor/HeartRateMonitor';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const HeartRateMonitorsSection: React.FC<{
  type: SETUP_STEP_TYPES;
}> = ({type}) => {
  return (
    <Section type={type}>
      <SectionHeader title="Get a heart rate monitor">
        <ul className={css.list_text}>
          <li>
            Pulsoid requires a{' '}
            <a
              href="https://blog.pulsoid.net/monitors"
              className={css.hyperlink_text}
              target="_blank"
            >
              Compatible monitor
            </a>{' '}
            to stream your heart rate.
          </li>
          <li>Chest strap & armband monitors ensure real-time updates.</li>
          <li>
            Smartwatches work with Pulsoid, but their accuracy may not be
            optimal.
          </li>
        </ul>
      </SectionHeader>
      <div className={css.section_heart_rate_monitors}>
        <div className={css.section_heart_rate_monitors_title}>
          Recommended heart rate monitors
        </div>
        <div className={css.section_heart_rate_monitors_text}>
          Accurate and comfortable heart rate monitors that ensure a real-time
          Pulsoid streaming experience.
        </div>
        <HeartRateMonitor
          link={devicesLinks.polarH10}
          img_link={imageLinks.polarH10}
          device_name="Polar H10"
          device_description="Chest Strap sensor"
          badge_text="Expert choice"
          price="$87"
          isExpertChoiceBadge={true}
        />
        <HeartRateMonitor
          link={devicesLinks.coospoH808S}
          img_link={imageLinks.coospoH808S}
          device_name="CooSpo H808S"
          device_description="Chest Strap sensor"
          badge_text="Entry level"
          price="$32"
          isScaled={true}
        />
        <HeartRateMonitor
          link={devicesLinks.polarVeritySense}
          img_link={imageLinks.polarVeritySense}
          device_name="Polar Verity Sense"
          device_description="Armband sensor"
          badge_text="Best value"
          price="$65"
        />
      </div>

      <div className={css.watches_section}>
        <div className={css.watches_header_title}>Smart devices</div>
        <div className={css.watches_header_text}>
          Pulsoid works with popular smart devices, each with its own app and
          connection method. Please see the tutorial below.
        </div>
        <div className={css.watches_content_container}>
          <img
            className={`${css.watches_image} ${css.image_scale}`}
            src={imageLinks.appleWatch}
          />
          <div>
            <div className={css.watches_content_title}>
              <a
                className={css.watch_link}
                href={devicesLinks.appleWatch}
                target="_blank"
              >
                Apple Watch
              </a>
              ,{' '}
              <a
                className={css.watch_link}
                href={devicesLinks.wearOS}
                target="_blank"
              >
                Wear OS
              </a>{' '}
              and{' '}
              <a
                className={css.watch_link}
                href={devicesLinks.fitbit}
                target="_blank"
              >
                FitBit
              </a>
            </div>
            <div className={css.watches_warning}>
              Smartwatches are a good start, but for better accuracy and battery
              life, a dedicated heart rate monitor is recommended.
            </div>
          </div>
        </div>
      </div>
      <div className={css.other_devices_section}>
        <ButtonV2
          size="small"
          className={css.other_devices_button}
          href="https://blog.pulsoid.net/monitors"
          target="_blank"
        >
          See all compatible devices
        </ButtonV2>
        <div className={css.other_devices_title}>
          Not sure about your device?
        </div>
        <div className={css.other_devices_text}>
          Ask in{' '}
          <a
            className={css.other_devices_hyperlink}
            href="https://discord.gg/STHkW4X"
            target="_blank"
          >
            Discord
          </a>{' '}
          or email us at{' '}
          <a
            className={css.other_devices_hyperlink}
            href="mailto:support@pulsoid.net"
            target="_blank"
          >
            support@pulsoid.net
          </a>
        </div>
      </div>
    </Section>
  );
};
